// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/conversion.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetConversionRequest, GetConversionResponse, GetConversionTimelineRequest, GetConversionTimelineResponse, SearchConversionsRequest, SearchConversionsResponse } from "./conversion_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.ConversionService
 */
export const ConversionService = {
  typeName: "tracker.v1.ConversionService",
  methods: {
    /**
     * @generated from rpc tracker.v1.ConversionService.SearchConversions
     */
    searchConversions: {
      name: "SearchConversions",
      I: SearchConversionsRequest,
      O: SearchConversionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ConversionService.GetConversion
     */
    getConversion: {
      name: "GetConversion",
      I: GetConversionRequest,
      O: GetConversionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ConversionService.GetConversionTimeline
     */
    getConversionTimeline: {
      name: "GetConversionTimeline",
      I: GetConversionTimelineRequest,
      O: GetConversionTimelineResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

